"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Modal = require("./Modal.styled");
var _flexComponents = require("../atoms/flex-components");
var _Text = _interopRequireDefault(require("../atoms/Text"));
var _ButtonIconOnly = require("../atoms/button/ButtonIconOnly");
var _Button = require("../atoms/button/Button");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * A modal for deletion
 *
 * @param closeModal A function that closes the modal
 * @param title The title for the modal header
 * @param destructiveButtonText Text for the destructive button
 * @param children The Modal content
 * @param onDeleteHandler The deletion function
 * @param size The size of the modal
 * @returns {JSX.Element} The Modal
 */
var DestructiveModal = function DestructiveModal(_ref) {
  var children = _ref.children,
    closeModal = _ref.closeModal,
    title = _ref.title,
    destructiveButtonText = _ref.destructiveButtonText,
    onDeleteHandler = _ref.onDeleteHandler,
    size = _ref.size;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.ModalContainer, {
    onClick: closeModal,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Modal.ModalBox, {
      onClick: function onClick(e) {
        return e.stopPropagation();
      },
      size: size,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_flexComponents.FlexRow, {
        justifyContent: 'space-between',
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
          type: 'heading',
          variant: 'xl',
          children: title
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonIconOnly.ButtonIconOnly, {
          size: 's',
          type: 'ghost',
          icon: 'close',
          onClick: closeModal
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.ContentContainer, {
        children: children
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_flexComponents.FlexRow, {
        alignItems: 'flex-end',
        justifyContent: 'flex-end',
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
          size: 'l',
          type: 'ghost',
          onClick: closeModal,
          children: "Cancel"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
          size: 'l',
          type: 'destructive',
          onClick: onDeleteHandler,
          children: destructiveButtonText
        })]
      })]
    })
  });
};
var _default = exports.default = DestructiveModal;
DestructiveModal.defaultProps = {
  closeModal: function closeModal(close) {
    return close;
  },
  title: 'Delete Title',
  destructiveButtonText: 'Delete'
};